/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Load_TitleInputs */



/**
* | output |
* | --- |
* | "Load Video Export Preset" |
*
* @param {Video_Export_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_load_title = /** @type {((inputs?: Video_Export_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger un prereglage d'exportation video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video-Export-Voreinstellung laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica preimpostazione esportazione video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузить предустановку экспорта видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar ajuste preestablecido de exportación de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载视频导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオエクスポートプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar predefinição de exportação de vídeo")
	return /** @type {LocalizedString} */ ("Load Video Export Preset")
});